export const PAGE_ID = 710;
export const PAGE_APP_VERSION = 1;
export const PAGE_TITLE = 'Crypto Signals';
export const APP_NAME = PAGE_TITLE;
export const BASE_URL = 'https://admin.connexbiz.com';
export const IMAGE_URL = 'https://file.connexbiz.com';

export const PAGE_SITE_URL = 'https://crypto-signal.connexbiz.com';
export const FB_APP_ID = '1780734263321606';
export const PAGE_THUMBNAIL_IMAGE = '';
export const PAGE_THUMBNAIL_URL = PAGE_THUMBNAIL_IMAGE
  ? `${IMAGE_URL}/uploads/${PAGE_THUMBNAIL_IMAGE}`
  : `${IMAGE_URL}/uploads/`;

export const ANDROID_PACKAGE_NAME = 'com.mws.cryptosignal';
export const IOS_BUNDLE_ID = 'io.mws.cryptosignal';

export const SUPPORT_FACEBOOK_URL = 'https://www.facebook.com/mwsdigitalagency/';
export const SUPPORT_MESSENGER_URL = 'https://m.me/mwsdigitalagency';
